import {useState, useEffect, useMemo} from 'react';

import styled from 'styled-components';
import config from '../../../config';
import BarGraph from '../../organisms/BarGraph';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import SelectModal, {SelectedLabel} from '../../organisms/SelectModal';
import {useApp} from '../../../contexts/AppContext';

import moment from 'moment';

const GraphWrap = styled.div`
  position: relative;
`;

const CustomSelectedLabel = styled.div`
  text-align: center;
  border-top: 1px solid #000000;
  border-bottom: 1px solid #000000;
  height: 44px;
  line-height: 42px;
  font-size: 14px;
  font-weight: bold;
  cursor: default;
  position: relative;
  background-color: #000000;
  color: #ffffff;
  
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 35px 0 20px;
  flex: 0 0 auto;
  width: calc((100% - 2px) / 2);

  &:last-child {
    width: calc((100% - 2px) / 2);
  }

  &::after {
    content: "";
    position: absolute;
    display: block;
    width: 11px;
    height: 8px;
    border-top: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    right: 15px;
    top: 50%;
    margin-top: -4px;
  }
  
  &.in_touch {
    background-color: #ffffff;
    color: #000000;

    &::after {
      border-color: #000000;
    }
  }

  @media ${config.layout.wide} {
    transition: background-color 0.15s linear, color 0.15s linear;
    @media (hover: hover) {
      &:hover {
        background-color: #ffffff;
        color: #000000;

        &::after {
          border-color: #000000;
        }
      }
    }
  }

`;

const GraphSelectUIWrap = styled.div`
  position: absolute;
  right: 1px;
  top: 0;
  left: 1px;
  height: 44px;
  display: flex;
  gap: 1px;
  justify-content: space-between;
  @media ${config.layout.wide} {
    top: 0;
  }
`;

const YearMonthLabel = styled.div`
  display: none;
  @media ${config.layout.wide} {
    display: block;
    position: absolute;
    top: 74px;
    left: 20px;
    font-size: 18px;
    font-weight: bold;
  }
`;

function DataGraph({type, roomID, room_graphs, year, month}) {

  let values = [];
  console.log(type, roomID);
  if (room_graphs && year && month) {
    const lastDay = parseInt(
        moment.utc(`${year}-${(month + '').padStart(2, '0')}-01`).
            add(1, 'month').
            add(-1, 'day').
            format('D'),
        10,
    );

    const rooms = room_graphs[type] || [];
    const room =
        rooms.find((room) => room.id === roomID) || null;
    const data = (room && room.values) || [];
    const dayMap = new Map();
    data.forEach((row) => {
      dayMap.set(row.date, row);
    });

    let m = moment.utc(
        `${year}-${(month + '').padStart(2, '0')}-01`,
    );
    for (let i = 1; i <= lastDay; i++) {
      const dt = m.format('YYYY-MM-DD');
      let row = dayMap.get(dt);
      values.push({
        date: m.toDate(),
        value: (row && row.value) || 0,
        na: !row,
      });
      m.add(1, 'day');
    }
  }

  return (
      <div>
        <BarGraph values={values} unit={type}/>
      </div>
  );
}

export default function VenueReportGraph({
  rooms,
  room_graphs,
  year,
  month,
}) {
  const [type, setType] = useState('tracks');
  const [roomID, setRoomID] = useState(0);
  const [typeModalIsOpen, setTypeModalIsOpen] = useState(false);
  const [roomModalIsOpen, setRoomModalIsOpen] = useState(false);

  const onClickType = () => {
    setTypeModalIsOpen(true);
  };

  const closeTypeModal = () => {
    setTypeModalIsOpen(false);
  };

  const types = [
    {
      value: 'tracks',
      label: 'Tracks',
    },
    {
      value: 'hours',
      label: 'Hours',
    },
  ];

  const typeItemSelect = (index) => {
    setTypeModalIsOpen(false);
    setType(types[index].value);
  };

  //console.log(rooms);
  const onClickRoom = () => {
    setRoomModalIsOpen(true);
  };

  const closeRoomModal = () => {
    setRoomModalIsOpen(false);
  };

  const roomItemSelect = (index) => {
    setRoomID(rooms[index].id);
    setRoomModalIsOpen(false);
  };

  useEffect(() => {
    setRoomID(0);
  }, [room_graphs]);

  const yearMonthStr = useMemo(() => {
    if (!month) {
      return '';
    }
    let date = new Date();
    date.setFullYear(year);
    date.setDate(10);
    date.setMonth(month - 1);
    return moment(date).format('MMM YYYY').toUpperCase();
  }, [year, month]);

  return (
      <>
        <GraphWrap>
          <DataGraph type={type} roomID={roomID} room_graphs={room_graphs}
                     month={month} year={year}/>
          <GraphSelectUIWrap>

            <CustomSelectedLabel onClick={onClickRoom}
                                 className="in_touch_target"

            >{rooms.find(t => t.id === roomID)?.name ||
                ''}</CustomSelectedLabel>
            <SelectModal
                title="Room/Floor"
                candidates={rooms.map((room) => room.name)}
                selectedIndex={rooms.reduce((p, c, i) => {
                  if (p >= 0) {
                    return p;
                  }
                  if (roomID === c.id) {
                    return i;
                  }
                  return p;
                }, -1)}
                closeModal={closeRoomModal}
                modalIsOpen={roomModalIsOpen}
                itemSelect={roomItemSelect}
            />

            <CustomSelectedLabel onClick={onClickType}
                                 className="in_touch_target"
            >{types.find(t => t.value === type).label}</CustomSelectedLabel>
            <SelectModal
                title="Type"
                candidates={types.map(t => t.label)}
                selectedIndex={types.reduce((p, c, i) => {
                  if (p >= 0) {
                    return p;
                  }
                  if (type === c.value) {
                    return i;
                  }
                  return p;
                }, -1)}
                closeModal={closeTypeModal}
                modalIsOpen={typeModalIsOpen}
                itemSelect={typeItemSelect}
            />

          </GraphSelectUIWrap>
          <YearMonthLabel>{yearMonthStr}</YearMonthLabel>
        </GraphWrap>
      </>
  );
}
